import React, { useState, memo } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MainButton from "../../shared/Button";
import { IconButtonMain, DialogMain } from "../accounting/styles/DialogStyles";
import { OrderDriverPopupMain } from "./styles/AssignOrderDriverPopupStyle";
import BroadcastFormPopup from "./BroadcastFormPopup";

const BroadcastPopup = ({ open, handleClose = () => {}, SelectedRow = {} }) => {
  const [broadcastopenDialog, setbroadcastOpenDialog] = useState(false);

  const BroadcasthandleCloseDialog = () => {
    setbroadcastOpenDialog(false);
  };
  const OpenBroadcastPopup = () => {
    setbroadcastOpenDialog(true);
    handleClose();
  };

  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6>Select radius to broadcast the job</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <OrderDriverPopupMain>
            <label>Pickup Location</label>
            <input
              type="text"
              placeholder="Pickup Location"
              value={SelectedRow?.PickupLocation || ""}
              disabled
            />
            <MainButton
              type="submit"
              label="Broadcast Job"
              MT="10"
              onClick={OpenBroadcastPopup}
            />
          </OrderDriverPopupMain>
        </DialogContent>
      </DialogMain>
      <BroadcastFormPopup
        open={broadcastopenDialog}
        handleClose={BroadcasthandleCloseDialog}
        order_id={SelectedRow?.order_id}
        orderPrice={SelectedRow?.Price}
      />
    </>
  );
};

export default memo(BroadcastPopup);
